import React, { useEffect, useState, useRef, VFC, ChangeEvent, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import './historyView.scss';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import moment from 'moment';
import { useAuth } from '@/lib/auth';
import Utils from '@/utils/util';
import { User } from '@/types';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { PageHeader } from '@/components/PageHeaders/PageHeader';
import { ReactComponent as LastCoverageIcon } from '@/assets/steam/last-coverage.svg';
import { ReactComponent as Calendericon } from '@/assets/steam/date-frame.svg';
import { ReactComponent as Coverageicon } from '@/assets/steam/coverage-frame.svg';
import { ReactComponent as ProductIcon } from '@/assets/steam/product.svg';
import { ReactComponent as Statusicon } from '@/assets/steam/funnel-frame.svg';
import { ReactComponent as BookIcon } from '@/assets/steam/quotes.svg';
import { ReactComponent as DownloadIcon } from '@/assets/steam/download-grey.svg';
import { ReactComponent as BookFunnelIcon } from '@/assets/steam/book-funnel.svg';
import { ReactComponent as ProductFunnelicon } from '@/assets/steam/product-funnel.svg';
import QuotesDialog from '../historyComponent/quotesDialog';
import { Quote } from '../types/indes';
import { useGetQuoteList } from '../api/quotesApi';
import { FUNNEL_TYPES, QUOTES_STATUS } from '@/utils/constants';
import HistoryDialog from '../historyComponent/historyDialog';
import { useGetHistory } from '../api/getHistory';
import FunnelHistoryView from './funneHistoryView';
import { useGetUsersList } from '@/features/users/api/getProducts';
import { Product } from '@/features/product/types/indes';
import { useGetProductList } from '@/features/product/api/getProduct';
import { saveAs } from 'file-saver';
import axios from 'axios';


const HistoryView: VFC<{
    open?: boolean;
    states?: any;
    selectedFunnel?: any;
    addNewFunnel?: boolean;
    usersListData?:any
    productList:any;
}> = ({ open, states, selectedFunnel , addNewFunnel = false, usersListData, productList}) => {
    const { user } = useAuth();
    const [quoteList, setQuoteList] = useState<Quote[]>([]);
    const useGetUsersMutation = useGetQuoteList();
    const useGetUsersMutations = useGetUsersList();
    const [isOpenHistoryDialog, setIsopenHistoryDialog] = useState('');
    const [isOpenQuotesDialog, setIsopenQuotesDialog] = useState(false);
    const [historyDetailss, setHistoryDetails] = useState<any>('')
    const useGetHistoryMutation = useGetHistory();
    const [usersList, setUsersList] = useState<User[]>([]);
    const [allProductList, setAllProductsList] = useState<Product[]>([]);
    const useGetProductMutation = useGetProductList();

    useEffect(() => {
        if(selectedFunnel){
            getQuotesList(1, true)
            getFunnelHistoryDetails('funnelHistory', selectedFunnel.id)
          
        }
       // getUsersList(1);
       // getProductList();
            
    }, [selectedFunnel])
    const getQuotesList = async (pageIndex: number, reset = false,) => {
        const res = await useGetUsersMutation.mutateAsync({
            page: pageIndex,
            perPage: 1,
            search: '',
            funnelId: selectedFunnel?.id
        });
        setQuoteList(res.list);
    };

    const getFunnelHistoryDetails = async(column:any, id:any)=>{
        const res = await useGetHistoryMutation.mutateAsync({
            id, column, instituteId: selectedFunnel?.institute?.id
        });

        if (res) {
            setHistoryDetails(res?.history)
        }else{
            setHistoryDetails(null);
        }
    }

    const getProductList = async () => {
        const res = await useGetProductMutation.mutateAsync({
            page: 1,
            perPage: 100,
            search: '',
            filter: '',
        });
       
        setAllProductsList(res.list)

    };
    const getQuantity = (item: any) => {
        return item.reduce((sum: any, product: any) => Number(sum) + Number(product.quantity), 0);
    }

    const getQuotesStatus = (id: any) => {
        if (id === QUOTES_STATUS.REQUESTED) {
            return 'Requested'
        } else if (id === QUOTES_STATUS.IN_PROGRESS) {
            return 'In progress'
        } else if (id === QUOTES_STATUS.REJECTED) {
            return 'rejected'
        } else if (id === QUOTES_STATUS.COMPLETED) {
            return 'Approved'
        } else {
            ''
        }
    }

    const getUsersList = async (pageIndex: number, reset = false, filter?: any) => {
        const res = await useGetUsersMutations.mutateAsync({
          page: pageIndex,
          perPage: 500,
          search: '',
          filter: { 'rolesId': [1, 2, 3, 4] },
        });
        setUsersList(res.list);
    
      };

      const DownloadPdf = async (pdfLink: string, updatedDate: string) => {
        try {
          // Fetch the PDF file from the link
          const fileName = `Quotation - ${Utils.formatAnyDate(updatedDate)}.pdf`;

    // Create a temporary link element
    const link = document.createElement('a');
    link.href = pdfLink;
    link.target = '_blank';
    link.download = fileName; // Suggested file name for download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
          console.log('File downloaded successfully!');
        } catch (error) {
          console.error('Error downloading the file:', error);
        }
      };
      
    
    return (
        <>
          {addNewFunnel ? <div className='no-data-found item-alignment width-set'> No Data! </div> :  <div className='history-view-container'>
            <div className='funnel-history-container'>
                <div className='funnel-history-details'>
                    <div className='institute-name-details'>
                        <div className='institute-name'>
                            Funnel History
                        </div>
                    </div>
                    <div className='history-funnel-btn'>
                        <div className='his-btn'>
                            <button
                                className={`steam-button button-dark display-flex`}
                                onClick={()=>{setIsopenHistoryDialog('funnelHistory'); getFunnelHistoryDetails('funnelHistory', selectedFunnel.id)}}
                            >
                                <span>View all</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className='history-scroll'>
                <FunnelHistoryView productList={productList} usersListData={usersListData} historyDetailssData={historyDetailss} selectedFunnel={selectedFunnel}/>
                </div>
           
                {/* <div className='history-view-details'>
                    <div className='history-div'>
                        <div className='history-user-name'>
                            <div className='name-details'>
                                Harsh Turkar
                            </div>
                            <div className='time-details'>
                                3Aug 2024, 9:12 AM
                            </div>
                        </div>
                        <div className='history-mapping'>
                            <div className='statues-ion'>
                                <Statusicon />
                                <div className='horizontal-line'>
                                </div>
                            </div>
                            <div className='details-div'>
                                <div className='ttile'>
                                    Funnel state updated
                                </div>
                                <div className='display-detail'>
                                    <span>Demo scheduled</span> {"->"} <span className='pro'> Initial interest</span>
                                </div>
                            </div>
                        </div>
                        <div className='history-mapping'>
                            <div className='statues-ion'>
                                <Calendericon />
                                <div className='horizontal-line'>
                                </div>
                            </div>
                            <div className='details-div'>
                                <div className='ttile'>
                                    Funnel state updated
                                </div>
                                <div className='display-detail'>
                                    <span>Demo scheduled</span> {"->"} <span className='pro'> Initial interest</span>
                                </div>
                            </div>
                        </div>
                        <div className='history-mapping'>
                            <div className='statues-ion'>
                                <Coverageicon />
                                <div className='horizontal-line'>
                                </div>
                            </div>
                            <div className='details-div'>
                                <div className='ttile'>
                                    Funnel state updated
                                </div>
                                <div className='display-detail'>
                                    <span>Demo scheduled</span> {"->"} <span className='pro'> Initial interest</span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div> */}
                {/* <div className='footer-overflow'></div> */}
            </div>

            <div className='quotes-container'>
                <div className='quotes-history-details'>
                    <div className='quotes-name-details'>
                        <div className='quotes-name'>
                            Quote Record
                        </div>
                    </div>
                    <div className='history-funnel-btn'>
                        <div className='his-btn'>
                            <button
                                className={`steam-button button-dark display-flex`}
                                onClick={() => { setIsopenQuotesDialog(true) }}
                            >
                                <span>View all</span>
                            </button>
                        </div>
                    </div>
                </div>
                {quoteList && quoteList.length === 0 && <div className='no-data-found item-alignment'> No Data!</div>}
                {quoteList && quoteList.length > 0 && quoteList.map((item: any) => {
                    return (
                        <div className='quotes-detail'>
                            <div className='quotes-title'>
                                <div className='quote-name'>

                                    <div className='iconn'>
                                        { <BookIcon /> }

                                    </div>
                                    <div className='datee'>
                                        <div className='bq'>
                                            {item.title}
                                        </div>
                                        <div className='dq'>
                                            {Utils.formatAnyDate(item.createdAt)}
                                        </div>

                                    </div>

                                </div>
                                <div className='quote-amount'>
                                <span>{Utils.convertDealSize(Number(item.requestedPrice))}</span>
                                </div>

                            </div>
                            <div className='quote-current-status'>
                                <div className='quote-type'>
                                    <div className='type-title'>
                                        Product type
                                    </div>
                                    <div className='type-name'>
                                            <div className={`funnels-bg ${selectedFunnel?.type === FUNNEL_TYPES.BOOK_FUNNEL ? 'change-bg' : ''}`}>  {selectedFunnel?.type !== FUNNEL_TYPES.BOOK_FUNNEL ? <BookFunnelIcon className='book-funnel-icon'/> :<ProductFunnelicon className='book-funnel-icon' /> }  {selectedFunnel?.type === FUNNEL_TYPES.BOOK_FUNNEL ? 'Books' : 'Platform'} </div>
                                        </div>

                                </div>
                                {selectedFunnel?.type === FUNNEL_TYPES.BOOK_FUNNEL && <div className='quote-type'>
                                    <div className='type-title'>
                                        Total products
                                    </div>
                                    <div className='type-name'>
                                        {item.productGroups && item.productGroups.length}
                                    </div>

                                </div>}
                                <div className='quote-type'>
                                    <div className='type-title'>
                                        Total quantity
                                    </div>
                                    <div className='type-name'>
                                        {selectedFunnel?.type === FUNNEL_TYPES.BOOK_FUNNEL ? `${getQuantity(item.productGroups)} Units` : '1 Unit'}
                                    </div>

                                </div>
                                <div className='quote-type'>
                                    <div className='type-title'>
                                        Quote status
                                    </div>
                                    <div className='type-name'>
                                        {getQuotesStatus(Number(item?.statusId))}  {Number(item?.statusId) === QUOTES_STATUS.COMPLETED && <div onClick={()=>{DownloadPdf(item?.pdfLink, item.updatedAt)}}><DownloadIcon /></div>}
                                       
                                    </div>

                                </div>
                                {Number(item?.statusId) === QUOTES_STATUS.COMPLETED && <div className='quote-type'>
                                    <div className='type-title'>
                                      PDF uploaded on 
                                    </div>
                                    <div className='type-name'>
                                    {Utils.formatAnyDate(item.updatedAt)}

                                    </div>

                                </div>}
                                

                            </div>

                        </div>)
                })}

            </div>
            {isOpenQuotesDialog && <QuotesDialog productList={productList} selectedFunnel={selectedFunnel} funnetType={1} open={isOpenQuotesDialog} onClose={() => { setIsopenQuotesDialog(false); }} onConfirm={() => { setIsopenQuotesDialog(false); }} />}
            {isOpenHistoryDialog && <HistoryDialog  productList={productList} usersListData={usersListData} selectedFunnel={selectedFunnel} funnetType={selectedFunnel?.type} historyDetailss={historyDetailss} open={isOpenHistoryDialog ? true : false} title={isOpenHistoryDialog} onClose={()=>{setIsopenHistoryDialog(''); setHistoryDetails('')}} onConfirm={()=>{setIsopenHistoryDialog(''); setHistoryDetails('')}}/>}
       
        </div>}
        </>
    );
};




export default HistoryView;
